import { ApiCall, ParameterTypes } from '@lcms/api-definition';
import endpoints from '../api-endpoint-definition.json';
import { ApiResponse } from './api-response';

const definition = new ApiCall<ApiResponse>().post('addTrendingResource', { 
    route: endpoints.adminTrendingResourcesAdd,
    params: {
        url: {
            type: ParameterTypes.String
        },
        title: {
            type: ParameterTypes.String
        }
    }
})
export default definition;